<template>
  <!-- 수정 모드 지원 (2026-07-12): shipment prop 전달 시 수정, 없으면 신규 -->
  <el-dialog v-model="visible" :title="isEdit ? '선적 수정' : '신규 선적'" width="700px" destroy-on-close>
    <el-form ref="formRef" :model="form" :rules="rules" label-width="100px">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="선적번호" prop="shipment_number">
            <el-input v-model="form.shipment_number" placeholder="예: SHP-2024-001" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="유형" prop="shipment_type">
            <el-select v-model="form.shipment_type" style="width: 100%">
              <el-option label="해상" value="SEA" />
              <el-option label="항공" value="AIR" />
              <el-option label="특송" value="EXPRESS" />
              <el-option label="육상" value="LAND" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="법인" prop="company">
            <el-select v-model="form.company" filterable clearable placeholder="법인 선택" style="width: 100%">
              <el-option v-for="c in codeStore.ourCompanys" :key="c.id" :label="c.name" :value="c.id" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="LC">
            <el-select v-model="form.lc" placeholder="LC 선택" clearable style="width: 100%">
              <el-option
                v-for="lc in lcs"
                :key="lc.id"
                :label="lc.lc_number"
                :value="lc.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="24">
          <!-- 메인오더 선택화 (2026-07-12) — 공통자재 선적은 비워두세요 -->
          <el-form-item label="메인오더">
            <el-select
              v-model="form.main_request"
              placeholder="지시서 선택 — 공통자재 선적은 비워두세요"
              filterable
              clearable
              style="width: 100%"
            >
              <el-option
                v-for="mr in mainRequests"
                :key="mr.id"
                :label="`${mr.request_number} - ${mr.brand_name}`"
                :value="mr.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="수량" prop="quantity">
            <el-input-number v-model="form.quantity" :min="0" style="width: 100%" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="카톤수">
            <el-input-number v-model="form.carton_count" :min="0" style="width: 100%" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="총중량(kg)">
            <el-input-number v-model="form.gross_weight" :min="0" :precision="2" style="width: 100%" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="선적항" prop="port_of_loading">
            <el-input v-model="form.port_of_loading" placeholder="예: 인천" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="양륙항" prop="port_of_discharge">
            <el-input v-model="form.port_of_discharge" placeholder="예: 하이퐁" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="ETD" prop="etd">
            <el-date-picker v-model="form.etd" type="date" value-format="YYYY-MM-DD" style="width: 100%" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="ETA" prop="eta">
            <el-date-picker v-model="form.eta" type="date" value-format="YYYY-MM-DD" style="width: 100%" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="선사">
            <el-input v-model="form.carrier" placeholder="예: Evergreen" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="선박명">
            <el-input v-model="form.vessel_name" />
          </el-form-item>
        </el-col>
      </el-row>

      <!-- BL/컨테이너 (2026-07-12) — 부킹 전 미정이면 비워두고 선적완료 시 입력 가능 -->
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="B/L번호">
            <el-input v-model="form.bl_number" placeholder="미정 시 비움 (선적완료 시 입력 가능)" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="컨테이너번호">
            <el-input v-model="form.container_number" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item label="비고">
        <el-input v-model="form.remarks" type="textarea" :rows="2" />
      </el-form-item>
    </el-form>

    <template #footer>
      <el-button @click="visible = false">취소</el-button>
      <el-button type="primary" @click="handleSubmit">저장</el-button>
    </template>
  </el-dialog>
</template>

<script setup>
import { ref, reactive, computed, watch, onMounted } from 'vue'
import { ElMessage } from 'element-plus'
import axiosInstance from '@/api/axios'
import { useCodeStore } from '@/stores/codeStore'

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  },
  defaultData: {
    type: Object,
    default: null
  },
  // 수정 대상 (2026-07-12) — 전달 시 수정 모드
  shipment: {
    type: Object,
    default: null
  }
})

const emit = defineEmits(['update:modelValue', 'saved'])

const codeStore = useCodeStore()
const visible = ref(props.modelValue)
const formRef = ref(null)
const mainRequests = ref([])
const lcs = ref([])

const isEdit = computed(() => !!props.shipment?.id)

const getDefaultForm = () => ({
  shipment_number: '',
  shipment_type: 'SEA',
  company: null,
  main_request: null,
  lc: null,
  quantity: 0,
  carton_count: 0,
  gross_weight: 0,
  port_of_loading: '',
  port_of_discharge: '',
  etd: '',
  eta: '',
  carrier: '',
  vessel_name: '',
  bl_number: '',
  container_number: '',
  remarks: ''
})

const form = reactive(getDefaultForm())

const rules = {
  shipment_number: [{ required: true, message: '선적번호를 입력하세요', trigger: 'blur' }],
  // 메인오더 필수 해제 (2026-07-12) — 공통자재 선적은 지시서 없이 진행
  quantity: [{ required: true, message: '수량을 입력하세요', trigger: 'blur' }],
  port_of_loading: [{ required: true, message: '선적항을 입력하세요', trigger: 'blur' }],
  port_of_discharge: [{ required: true, message: '양륙항을 입력하세요', trigger: 'blur' }],
  etd: [{ required: true, message: 'ETD를 선택하세요', trigger: 'change' }],
  eta: [{ required: true, message: 'ETA를 선택하세요', trigger: 'change' }]
}

const fetchData = async () => {
  try {
    const [mrRes, lcRes] = await Promise.all([
      axiosInstance.get('production/main-requests/'),
      axiosInstance.get('lcs/')
    ])
    mainRequests.value = mrRes.data.results || mrRes.data
    lcs.value = lcRes.data.results || lcRes.data
  } catch (error) {
    console.error('Failed to fetch data:', error)
  }
}

const handleSubmit = async () => {
  await formRef.value.validate()

  try {
    if (isEdit.value) {
      await axiosInstance.put(`shipments/${props.shipment.id}/`, form)
      ElMessage.success('선적이 수정되었습니다.')
    } else {
      await axiosInstance.post('shipments/', form)
      ElMessage.success('선적이 등록되었습니다.')
    }
    emit('saved')
    visible.value = false
  } catch (error) {
    const detail = error.response?.data
    const msg = detail?.shipment_number?.[0] || detail?.error || '저장에 실패했습니다.'
    ElMessage.error(msg)
    console.error(error)
  }
}

watch(() => props.modelValue, async (val) => {
  visible.value = val
  if (!val) return
  if (props.shipment?.id) {
    // 수정 모드 — 상세 조회로 전체 필드 채움 (목록 응답엔 컨테이너/중량/비고 없음)
    let s = props.shipment
    try {
      const res = await axiosInstance.get(`shipments/${props.shipment.id}/`)
      s = res.data
    } catch (e) {
      console.error('선적 상세 조회 실패:', e)
    }
    Object.assign(form, {
      shipment_number: s.shipment_number,
      shipment_type: s.shipment_type,
      company: s.company ?? null,
      main_request: s.main_request ?? null,
      lc: s.lc ?? null,
      quantity: Number(s.quantity) || 0,
      carton_count: s.carton_count != null ? Number(s.carton_count) : 0,
      gross_weight: s.gross_weight != null ? Number(s.gross_weight) : 0,
      port_of_loading: s.port_of_loading || '',
      port_of_discharge: s.port_of_discharge || '',
      etd: s.etd || '',
      eta: s.eta || '',
      carrier: s.carrier || '',
      vessel_name: s.vessel_name || '',
      bl_number: s.bl_number || '',
      container_number: s.container_number || '',
      remarks: s.remarks || ''
    })
  } else {
    Object.assign(form, getDefaultForm())
    if (props.defaultData?.main_request) form.main_request = props.defaultData.main_request
  }
})

watch(visible, (val) => {
  emit('update:modelValue', val)
})

onMounted(() => {
  fetchData()
  codeStore.fetchOurCompanys()
})
</script>
